import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  generalDataLength: 0,
  generalData: [],
  genData: {},
  generalDataError: "",
  formError: "",
  formErrorJson: {},
};

export default function generalDataReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_GENERAL_DATA:
      return { ...state, loading: action.payload };
    case actions.LOADING_GENERAL_DATA_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_GENERAL_DATA:
      return { ...state, saveLoading: action.payload };
    case actions.GET_GENERAL_DATA:
      return {
        ...state,
        generalData: action.payload.generalData,
        generalDataLength: action.payload.generalDataLength,
      };
    case actions.GET_GENERAL_DATA_BY_ID:
      return {
        ...state,
        genData: action.payload,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_FAIL_JSON:
      return { ...state, formErrorJson: action.payload };
    case actions.GENERAL_DATA_FAIL:
      return { ...state, titleError: action.payload };
    default:
      return state;
  }
}
